<template>
  <div class='ExportCard'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>

    <div class="centerBox">
      <div class="centerBoxItem1">
        <div class="topTitle">制卡</div>
        <div class="nameTitle">入库/制卡</div>
        <div class="flexBox p1">
          <span>数量占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">入库数量：{{progressData.inboundCount}}</div>
              <div>制卡数量：{{progressData.genCardCount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.inboundCount/(progressData.genCardCount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div>
          <div class="showAll" @click="handleSearch(3)">显示全部......</div>
          <div class="showText" v-for="item in errorData.unInbound || []" :key="item.cardNo">
            {{item.cardNo}} {{item.bindTime}}
          </div>
        </div>
      </div>
      <div class="centerBoxItem1">
        <div class="topTitle">入库</div>
        <div class="nameTitle">售卡/入库</div>
        <div class="flexBox p2">
          <span>数量占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">售卡数量：{{progressData.sellCount}}</div>
              <div>入库数量：{{progressData.inboundCount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.sellCount/(progressData.inboundCount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div>
          <div class="showAll" @click="handleSearch(4)">显示全部......</div>
          <div class="showText" v-for="item in errorData.unSell || []" :key="item.cardNo">
            {{item.cardNo}} {{item.bindTime}}
          </div>
        </div>
      </div>
      <div class="centerBoxItem1">
        <div class="topTitle">售卡</div>
        <div class="nameTitle">绑卡/售卡</div>
        <div class="flexBox p3" style="margin-bottom: 10px;">
          <span>金额占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">绑卡金额：{{progressData.bindAmount}}</div>
              <div>售卡金额：{{progressData.sellAmount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.bindAmount/(progressData.sellAmount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div class="flexBox p4">
          <span>数量占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">绑卡数量：{{progressData.bindCount}}</div>
              <div>售卡数量：{{progressData.sellCount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.bindCount/(progressData.sellCount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div>
          <div class="showAll" @click="handleSearch(5)">显示全部......</div>
          <div class="showText" v-for="item in errorData.stateInvalid || []" :key="item.cardNo">
            {{item.cardNo}} {{item.bindTime}}
          </div>
        </div>
      </div>
      <div class="centerBoxItem1">
        <div class="topTitle">绑卡</div>
        <div class="nameTitle">消费/绑卡</div>
        <div class="flexBox p5" style="margin-bottom: 10px;">
          <span>金额占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">消费金额：{{progressData.consumeAmount}}</div>
              <div>绑卡金额：{{progressData.bindAmount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.consumeAmount/(progressData.bindAmount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div class="flexBox p6">
          <span>数量占比：</span>
          <el-popover
            style="flex:1;cursor: pointer;"
            trigger="hover"
            width="160">
            <div>
              <div style="margin-bottom:10px">消费数量：{{progressData.consumeCount}}</div>
              <div>绑卡数量：{{progressData.bindCount}}</div>
            </div>
            <el-progress color="#adc5f2" :text-inside="true" :stroke-width="40" :percentage="Number(((progressData.consumeCount/(progressData.bindCount || 1))*100).toFixed(0))" slot="reference"></el-progress>
          </el-popover>
        </div>
        <div>
          <div class="showAll" @click="handleSearch(6)">显示全部......</div>
          <div class="showText" v-for="item in errorData.repeatBind || []" :key="item.cardNo">
            {{item.cardNo}} {{item.bindTime}}
          </div>
        </div>
      </div>
      
    </div>

    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:cardNature="{ item }">
        <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getAllShow"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { optionsDataReplace } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      failType: null,
      progressData:{},
      errorData:{},
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, placeholder: '请选择卡类型' },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ],
        searchHandleSpan: 4
      },

      multipleSelection: [], // 选中的
      Table: { // 表格
        title: '异常信息列表',
        primaryBtn: {
          show: true,
          html: '导出',
          handle: () => this.defaultEvent()
        },
        data: [],
        column: [
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'batchSn', label: '卡批次' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'creatTime', label: '制卡时间' },
          { prop: 'creator', label: '制卡人' },
          { prop: 'auditCreator', label: '制卡人审核人' },
          { prop: 'inboundSn', label: '入库序列ID' },
          { prop: 'inboundDate', label: '入库时间' },
          { prop: 'inboundUser', label: '入库人' },
          { prop: 'auditInboundUser', label: '入库审批人' },
          { prop: 'bindAccountName', label: '会员姓名' },
          { prop: 'bindAccount', label: '会员卡号' },
          { prop: 'bindMarket', label: '绑卡项目' },
          { prop: 'bindTime', label: '绑卡时间' },
          { prop: 'failDescribe', label: '异常原因' },
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      // 从左到右 failType的值 分别是 3 4 5 6
      this.getProgress()
      this.geterrorBindShort()
      this.Table.data = []
      this.pager.page = 1
      this.pager.count = 0
    },

    searchResetForm () {
      this.search.searchData = {}
      this.Table.data = []
      this.pager.page = 1
      this.pager.count = 0
      // this.searchHandleForm()
    },
    // 进度条数据
    getProgress(){
      const { cardTypeId, issuingType} = this.search.searchData
      let params = {
        cardTypeId,
        issuingType
      }
      this.$http.riskBusiness(params).then(res=>{
        if(res.status == 200){
          this.progressData = res.data
        }
      })
    },
    // 获取简单错误信息
    geterrorBindShort(){
      const { cardTypeId, issuingType} = this.search.searchData
      let params = {
        cardTypeId,
        issuingType
      }
      this.$http.errorBindShort(params).then(res=>{
        if(res.status == 200){
          this.errorData = res.data
          for(let i in this.errorData){
            this.errorData[i] = (this.errorData[i] || []).slice(0,2)
          }
        }
      })
    },
    handleSearch(failType) {
      this.pager.page = 1
      this.failType = failType
      this.getAllShow()
    },
    // 显示全部
    getAllShow(){
      const { cardTypeId, issuingType} = this.search.searchData
      const { pager, Table } = this
      let params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        failType: this.failType,
        cardTypeId,
        issuingType
      }
      // 获取错误数据详情列表
      this.$http.errorBindList(params).then(res=>{
        if(res.status == 200){
          pager.count = res.data.total
          Table.data = res.data.list
        }
      })
    },
    // 导出
    defaultEvent(){
      if(this.failType && this.Table.data.length>0){
        const { cardTypeId, issuingType} = this.search.searchData
        // this.failType = failType
        let params = {
          failType: this.failType,
          cardTypeId,
          issuingType
        }
        this.$http.errorBindListExport(params).then(res=>{
          if(res.status == 200){
            this.$message.success('执行成功')
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getCardTypeList()
    this.getProgress()
    this.geterrorBindShort()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.centerBox{
    background: #fff;
    margin: 20px;
    display: flex;
    border-radius: 10px;
    .centerBoxItem1{
      border: solid 1px #e3e3e3;
      flex: 1;
      display: flex;
      flex-direction: column;
      .topTitle{
        padding: 2px 5px;
        background: #a29e9e;
        width: 40px;
        text-align: center;
      }
      .nameTitle{
        text-align: center;
        padding: 4px 0;
        margin-top: 10px;
      }
      .flexBox{
        flex: 1;
        display: flex;
        align-items: center;
        padding: 0 10px;
      }
      .showAll{
        text-align:right;
        color:#7398f9;
        margin-top: 25px;
        padding-right: 10px;
        padding-bottom: 4px;
        font-size: 14px;
        border-bottom: solid 1px #e3e3e3;
        cursor: pointer;
      }
      .showText{
        line-height: 35px;
        color: #F21111;
        text-align: center;
        border-bottom: solid 1px #e3e3e3;
      }
      .showText:last-child{
        border: none;
      }
    }
    .centerBoxItem1:nth-child(1){
      border-left: none;
    }
    .centerBoxItem1:nth-child(2){
      border-left: none;
    }
    .centerBoxItem1:nth-child(3){
      border-left: none;
    }
    .centerBoxItem1:nth-child(4){
      border-left: none;
      border-right: none;
    }
    ::v-deep .el-progress-bar__outer{
      border-radius: 0;
    }
    ::v-deep .el-progress-bar__inner{
      border-radius: 0;
    }
    ::v-deep .el-progress-bar__innerText{
      color: black;
    }
  }
  .p1{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
  .p2{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
  .p3{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
  .p4{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
  .p5{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
  .p6{
    ::v-deep .el-progress-bar__outer{
      background: #ebedf1;
    }
  }
</style>
